import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { IconButton, Typogaphy } from 'vnetwork-ui'
import TextEditorCustomize from '@/components/TextEditorCustomize'
import HelpIcons from '@/icons/HelpIcons'
import { useAppStore } from '@/stores/useAppStore'
import remedialMeasures from '@/modules/Ticket/help/ticket-remedial-measures-help.md'
import avoid from '@/modules/Ticket/help/ticket-avoid-help.md'
import { useTranslation } from 'react-i18next'

interface TicketCAPAProps {
    control: Control<any>
    viewOnly?: boolean
    /** If true, show all fields (remedial_measures + avoid). If false, only show remedial_measures */
    showAllFields?: boolean
}

const TicketCAPA: React.FC<TicketCAPAProps> = ({
    control,
    viewOnly = false,
    showAllFields = true,
}) => {
    const { t } = useTranslation()
    const { setIsShowHelp, setHelpContent, isShowHelp } = useAppStore()
    return (
        <div className="space-y-3">
            <div>
                <div className="flex items-center mb-1">
                    <Typogaphy size="small" className="mb-1">
                        {t('ticket-remedial-measures')}
                    </Typogaphy>
                    <IconButton
                        size="small"
                        className="mb-1"
                        onClick={() => {
                            setIsShowHelp(!isShowHelp)
                            setHelpContent(remedialMeasures)
                        }}
                    >
                        <HelpIcons className="text-black" />
                    </IconButton>
                </div>
                <Controller
                    control={control}
                    name="ticket_remedial_measures"
                    render={({ field, fieldState: { error } }) => {
                        const message =
                            error &&
                            typeof error === 'object' &&
                            'text' in (error as any)
                                ? (error as any).text?.message
                                : undefined

                        return (
                            <div>
                                <TextEditorCustomize
                                    disabled={viewOnly}
                                    disabledAttachments={true}
                                    value={
                                        typeof field.value === 'string'
                                            ? {
                                                  text: field.value,
                                                  attachments: [],
                                              }
                                            : field.value || {
                                                  text: '',
                                                  attachments: [],
                                              }
                                    }
                                    onChange={(val) => field.onChange(val)}
                                    imagePrefix="tickets"
                                />
                                {message && (
                                    <p className="text-red-500 text-sm mt-1">
                                        {message}
                                    </p>
                                )}
                            </div>
                        )
                    }}
                />
            </div>

            {showAllFields && (
                <div>
                    <div className="flex items-center mb-1">
                        <Typogaphy size="small" className="mb-1">
                            {t('ticket-avoid')}
                        </Typogaphy>
                        <IconButton
                            size="small"
                            className="mb-1"
                            onClick={() => {
                                setIsShowHelp(!isShowHelp)
                                setHelpContent(avoid)
                            }}
                        >
                            <HelpIcons className="text-black" />
                        </IconButton>
                    </div>
                    <Controller
                        control={control}
                        name="ticket_avoid"
                        render={({ field, fieldState: { error } }) => {
                            const message =
                                error &&
                                typeof error === 'object' &&
                                'text' in (error as any)
                                    ? (error as any).text?.message
                                    : undefined

                            return (
                                <div>
                                    <TextEditorCustomize
                                        disabled={viewOnly}
                                        disabledAttachments={true}
                                        value={
                                            typeof field.value === 'string'
                                                ? {
                                                      text: field.value,
                                                      attachments: [],
                                                  }
                                                : field.value || {
                                                      text: '',
                                                      attachments: [],
                                                  }
                                        }
                                        onChange={(val) => field.onChange(val)}
                                        imagePrefix="tickets"
                                    />
                                    {message && (
                                        <p className="text-red-500 text-sm mt-1">
                                            {message}
                                        </p>
                                    )}
                                </div>
                            )
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default TicketCAPA
